<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ព័ត៌មានអតិថិជន</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">

				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">លេខកូដអតិថិជន</md-table-cell>
						<md-table-cell style="width: 5px">៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.hash_id).length > 0">{{client.hash_id}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ឈ្មោះអតិថិជន</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name).length > 0">{{client.name}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ទីតាំង</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.location_name).length > 0">{{client.location_name}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<!-- <md-table-row>
						<md-table-cell>ទីតាំង Link</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.location_link).length > 0"><a :href="client.location_link" target="_blank"></a>{{client.location_link}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row> -->
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>Client Detail</h3> -->
				<md-table>
					<md-table-row>
						<md-table-cell>តេឡេក្រាម Link</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.telegram_link).length > 0">{{client.telegram_link}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ទីតាំង Link</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.location_link).length > 0"><a :href="client.location_link" target="_blank">{{client.location_link}}</a></span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>កំណត់ចំណាំផ្សេងៗ</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.note).length > 0">{{client.note}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ថ្ងៃបានបង្កើត</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.created_date).length > 0">{{config.datelify(client.created_date)}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<div class="bank-row">
					<div class="text-center">
						<p>គណនី USD</p>
						<img :src="config.getProfileUrl(client.bank_usd)" class="bank-image" style="width: 250px" />
					</div>
					<div class="text-center">
						<p>គណនី KHR</p>
						<img :src="config.getProfileUrl(client.bank_khr)" class="bank-image" style="width: 250px"  />
					</div>
					<div class="text-center">
						<p>គណនី Telegram</p>
						<img :src="config.getProfileUrl(client.telegram_qr)" class="bank-image" style="width: 250px" />
					</div>
				</div>
				
			</div>
			
			<!-- <div class="md-layout-item md-small-size-100 md-size-50">
				<h3>Loan Detail</h3>
				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">Total Loan Amount</md-table-cell>
						<md-table-cell style="width: 5px">៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name).length > 0">$5,000.00</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Total Loan</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name_khmer).length > 0">2 Loans</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Total payment</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.phone).length > 0">$6,300.00</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Remaining balance</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.note).length > 0">$4,725.00</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div> -->
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ព័ត៌មានស្ថិតិអំពីកញ្ចប់ឥវ៉ាន់</h3>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>today</md-icon>
					</template>
					<template slot="content">
						<p class="category">កញ្ចប់ឥវ៉ាន់ថ្ងៃនេះ</p>
						<h3 class="title">{{data.total_today}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>today</md-icon>
					</template>
					<template slot="content">
						<p class="category">កញ្ចប់ឥវ៉ាន់ ៧ ថ្ងៃចុងក្រោយ</p>
						<h3 class="title">{{data.total_7_day}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>today</md-icon>
					</template>
					<template slot="content">
						<p class="category">កញ្ចប់ឥវ៉ាន់ ៣០ ថ្ងៃចុងក្រោយ</p>
						<h3 class="title">{{data.total_30_day}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>today</md-icon>
					</template>
					<template slot="content">
						<p class="category">កញ្ចប់ឥវ៉ាន់សរុប</p>
						<h3 class="title">{{data.total_package}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>កញ្ចប់ឥវ៉ាន់ទាំងអស់</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="packageList.length > 0">
					<md-table-row>
						<!-- <md-table-head>ល.រ.</md-table-head> -->
						<md-table-head>លេខកូដ</md-table-head>
						<md-table-head>ប្រភេទ និងទីតាំង</md-table-head>
						<md-table-head>អ្នកទទួល</md-table-head>
						<md-table-head>អ្នកដឹកជញ្ជូន</md-table-head>
						<md-table-head>តម្លៃឥវ៉ាន់</md-table-head>
						<md-table-head>ថ្លៃដឹកជញ្ជូន</md-table-head>
						<md-table-head>ស្ថានភាព</md-table-head>
						<md-table-head>សកម្មភាព</md-table-head>
					</md-table-row>

					<md-table-row v-for="(pkg, index) in packageList">
						<!-- <md-table-cell></md-table-cell> -->
						<md-table-cell>​{{ index + 1 }}, <b>{{ pkg.tracking }}</b><br>{{config.datelify(pkg.created_date)}}
						</md-table-cell>
						<md-table-cell><b>{{ pkg.location }}</b><br>{{ pkg.package_type }}</md-table-cell>
						<md-table-cell>{{ pkg.receiver_phone }}</md-table-cell>
						<md-table-cell>
							<span v-if="pkg.status == 'ndv'">មិនមានអ្នកដឹក</span>
							<span v-else>{{ pkg.driver_phone }}<br>({{ pkg.driver_name }})</span>
						</md-table-cell>
						<md-table-cell><b>{{ config.moneylify(pkg.price, pkg.price_currency) }}</b><br><span
								v-if="pkg.price == 0">(ទូទាត់រួច)</span><span v-else>(មិនទាន់ទូទាត់)</span></md-table-cell>
						<md-table-cell><b>{{ config.moneylify(pkg.fee, pkg.fee_currency) }}</b><br>
							({{config.getStatus(pkg.fee_responsible)}})</md-table-cell>
						<md-table-cell>
							<span class="error" v-if="pkg.status == 'ndv'">{{ config.getStatus(pkg.status) }}</span>
							<span class="late" v-if="pkg.status == 'wdv'">{{ config.getStatus(pkg.status) }}</span>
							<span class="neutral" v-if="pkg.status == 'dvr'">{{ config.getStatus(pkg.status) }}</span>
							<span class="green" v-if="pkg.status == 'dlv'">{{ config.getStatus(pkg.status) }}</span>
							<span class="return" v-if="pkg.status == 'rtn'">{{ config.getStatus(pkg.status) }}</span>
						</md-table-cell>
						<md-table-cell>
							<router-link :to="'/packages/detail/' + pkg.hash_id">
								<md-button class="md-just-icon md-simple md-primary">
									<md-icon>visibility</md-icon>
									<md-tooltip md-direction="top">មើលលម្អិត</md-tooltip>
								</md-button>
							</router-link>
						</md-table-cell>

					</md-table-row>
				</md-table>
				<h4 class="text-center" v-if="packageList.length == 0 && loadMore == true">មិនមានកញ្ចប់ឥវ៉ាន់</h4>
				<div class="places-buttons text-center" v-if="loadMore">
					<md-button class="md-primary" @click="getPackage(true)">បង្ហាញបន្ថែម</md-button>
				</div>
			</div>
		</div>
	</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	import StatsCard from '@/components/Cards/StatsCard'
	export default {
		components: { Datetime, StatsCard },
		created() {

			// this.getLocation();
			// this.getSettings();
			this.getClient();
			this.getPackage();
			// this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				client: {
					hash_id: "",
					name: "",
					phone: "",
					note: "",
					created_date: ""
				},
				data: {
					total_package: 0,
					total_today: 0,
					total_7_day: 0,
					total_30_day: 0
				},
				loadMore: false,
				packageList: []

			}
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + "/admin/client/get/" + this.$route.params.hash_id).then(data => {
					this.client = data.body.data
					this.loaded = true;
				})
				this.$http.get(this.config.api + "/admin/client/get/package_stat/" + this.$route.params.hash_id).then(data => {
					this.data = data.body.data
				})
			},
			getPackage(more = false) {
				this.$http.post(this.config.api + "/admin/client/get/package", {
					hash_id: this.$route.params.hash_id,
					offset: more ? this.packageList.length : 0
				}).then(data => {
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.packageList = more ? this.packageList.concat(data.body.data) : data.body.data;
				})
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
	.bank-row {
		display: flex;
		justify-content:space-evenly;

	}
	.bank-image {
		width: 100%;
		/* margin: 0 50px; */
		padding: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/Detail.vue